import React from 'react';
import Page from 'framework7-react/components/page';

import {
  Icon,
  Link,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  List,
  ListItem,
  Popover,
  Fab
} from 'framework7-react';
import PropTypes from 'prop-types';
import II18 from '../../translate/II18';
import { RequestStepperNextButton } from '../../requestedDocuments/Elements';
import withViewer from '../withViewer';
import ViewerContent from './ViewerContent';
import { DOC_TYPE_IMMEDIATE_CONFIRMATION } from '../../helpers/utils';
import { DocumentRejectedMessage } from '../../common/DocumentRejectedMessage';
import {
  OpenMainInfoMenuItem,
  startPageHiddenBySettings
} from '../../common/OpenMainInfoLink';

class Viewer extends React.Component {
  constructor(props) {
    super(props);
    this.mainMenu = null;
  }

  componentWillUnmount() {
    /*if (this.mainMenu) {
      this.mainMenu.close();
      document.getElementById('mainMenu').remove();
    }*/
  }

  prepareConfirmButtonStyle(confirmText) {
    let fabStyle = 'tinyFab';
    if (confirmText.length > 20) {
      fabStyle = '';
    }
    if (confirmText.length >= 100) {
      fabStyle = 'fabText60';
    }
    if (confirmText.length >= 200) {
      fabStyle = 'fabText65';
    }
    if (confirmText.length >= 300) {
      fabStyle = 'fabText75';
    }
    return fabStyle;
  }

  render() {
    const {
      document,
      manyPagesRequestNextButton,
      forceBackwardAnimation,
      documentCanNavigateBack,
      doDownloadAttachment,
      printAttachment,
      confirmed,
      confirmText,
      onDocumentIsScrolledTillEnd,
      onShowConfirmationDialog,
      onShowUnConfirmationDialog,
      showAcceptDoneButton,
      showUnConfirmButton,
      showConfirmButton,
      showScrollButton,
      onDocumentDone,
      downloadRequired,
      onRejectDocument,
      scanEnded,
      documentRejectionAllowed,
      skipStartPage,
      skipStartPageOriginal
    } = this.props;

    const showMainInfoAccess = startPageHiddenBySettings({
      skipStartPage,
      skipStartPageOriginal
    });
    let fabStyle = this.prepareConfirmButtonStyle(confirmText);

    return (
      <Page
        className={
          (forceBackwardAnimation ? 'slide-in-left' : '') +
          (downloadRequired ? ' blur' : '')
        }
      >
        <Navbar>
          {documentCanNavigateBack && (
            <NavLeft>
              <Link id={'navigateBack'} onClick={this.props.navigateBack}>
                <Icon ios="f7:chevron_left" md="material:arrow_back" />{' '}
                {this.$f7.device.ios ? II18.get('title_back') : ''}
              </Link>
            </NavLeft>
          )}
          <NavTitle>
            <label>{`${document ? document.name : ''}`}</label>
          </NavTitle>
          <NavRight>
            <Link
              id={'mainMenuItem'}
              popoverOpen={'#mainMenu_' + document.id}
              href={false}
              iconColor={this.$f7.device.ios ? 'blue' : 'white'}
              iconMaterial={'more_vert'}
            />
          </NavRight>
        </Navbar>

        <Popover
          key={document.id}
          id={'mainMenu_' + document.id}
          targetEl={'#mainMenuItem'}
          ref={el => {
            this.mainMenu = el;
          }}
        >
          <List>
            <ListItem
              key={'print'}
              title={II18.get('title_print')}
              onClick={printAttachment}
            >
              <Icon slot="after" material={'print'} />
            </ListItem>
            <ListItem
              key={'download'}
              title={II18.get('title_download')}
              onClick={doDownloadAttachment}
            >
              <Icon slot="after" material={'file_download'} />
            </ListItem>

            {!confirmed &&
              documentRejectionAllowed &&
              !scanEnded &&
              document.type === DOC_TYPE_IMMEDIATE_CONFIRMATION && (
                <ListItem
                  id={'itemRejectDocument'}
                  popoverClose
                  title={II18.get('title_reject')}
                  onClick={() => {
                    this.$f7.popover.close();
                    setTimeout(onRejectDocument, 100);
                  }}
                >
                  <Icon slot="after" material={'block'} />
                </ListItem>
              )}
            {showMainInfoAccess && <OpenMainInfoMenuItem />}
          </List>
        </Popover>

        {showScrollButton && (
          <Fab
            className={'tinyFab'}
            id={'scrollButton'}
            position="right-bottom"
            slot="fixed"
            text={II18.get('title_had_read')}
            color="deeppurple"
            onClick={() => {
              onDocumentIsScrolledTillEnd();
              this.photoGallery.swiper.slideTo(document.attachment.length - 1);
            }}
          >
            <Icon material={'arrow_downward'} />
          </Fab>
        )}

        {showAcceptDoneButton && (
          <Fab
            id={'acceptButton'}
            style={{ bottom: 55 }}
            className={fabStyle}
            position="right-bottom"
            slot="fixed"
            text={II18.get('list_done')}
            color="blue"
            onClick={() => onDocumentDone(true)}
          >
            <Icon material={'check'} />
          </Fab>
        )}

        {showConfirmButton && (
          <Fab
            id={'acceptButton'}
            className={fabStyle}
            position="right-bottom"
            slot="fixed"
            text={confirmText}
            color="blue"
            onClick={onShowConfirmationDialog}
          >
            <Icon material={'check'} />
          </Fab>
        )}

        {showUnConfirmButton && (
          <Fab
            className={'tinyFab'}
            id={'cancelButton'}
            position={'left-bottom'}
            slot="fixed"
            text={II18.get('title_unconfirm_short')}
            color="gray"
            onClick={onShowUnConfirmationDialog}
          >
            <Icon material={'block'} />
          </Fab>
        )}

        {(confirmed || scanEnded) && manyPagesRequestNextButton && (
          <RequestStepperNextButton slot="fixed" onClick={onDocumentDone} />
        )}

        {document?.rejected && <DocumentRejectedMessage />}

        <ViewerContent
          {...this.props}
          onSetupGallery={galleryInstance => {
            this.photoGallery = galleryInstance;
          }}
        />
      </Page>
    );
  }
}

Viewer.propTypes = {
  documentRejectionAllowed: PropTypes.bool,
  scanEnded: PropTypes.bool,
  skipStartPage: PropTypes.bool,
  skipStartPageOriginal: PropTypes.bool,
  templateMode: PropTypes.bool,
  onRejectDocument: PropTypes.func,
  downloadRequired: PropTypes.bool,
  forceBackwardAnimation: PropTypes.bool,
  confirmed: PropTypes.bool,
  manyPagesRequestNextButton: PropTypes.bool,
  documentCanNavigateBack: PropTypes.bool,
  onDocumentDone: PropTypes.func,
  navigateBack: PropTypes.func,
  doDownloadAttachment: PropTypes.func,
  printAttachment: PropTypes.func,
  document: PropTypes.object,
  confirmText: PropTypes.string,
  onDocumentIsScrolledTillEnd: PropTypes.func,
  onShowConfirmationDialog: PropTypes.func,
  onShowUnConfirmationDialog: PropTypes.func,
  showAcceptDoneButton: PropTypes.bool,
  showUnConfirmButton: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  showScrollButton: PropTypes.bool
};

export default withViewer(Viewer);
